export default "src/content/themes/association-wordpress-theme/img/ab66b602b16d283966a4dc157cfc172c.png";